<template>
 <div>
	 <div class="leftfloat"><el-input class="searchInput" @keyup.enter.native="Search" v-model="val" placeholder="文章标题、作者、关键词、摘要" size="small" >

<i
    class="search_button"
    slot="suffix"
	style="font-size: 16px; color: #165e71 ;margin-right:5px"
	@click="Search">
  </i>
</el-input>
</div>
	 <div class="leftfloat ml5 highsearch"><a @click="AdvancedSearch" href="javascript:void(0);">高级检索</a></div>
	 <div class="clearfix"></div>
 </div>
</template>
<script>
export default {
  name: 'search',
  data () {
    return {
		val:""
    }
  },
  methods:{
	  //简单搜索
	  Search(){
		  if(this.val ==""){
			  alert('请填写检索内容')
		  }else{
			  this.$newOpen("/#/QuickSearch?isdatab=true")
			  localStorage.setItem("value",this.val)
			  }
	  },
	  //高级搜索
	  AdvancedSearch(){
		  	this.$router.push("/AdvancedSearch?isdatab=true")
	  }
  }
}
</script>
<style>
.searchInput .el-input__inner{
	border-radius: 30px !important;
}
.searchInput .el-input__suffix{
	line-height: 35px;
	    right: -20px !important;
}
.el-input--suffix .el-input__inner{

}
.search .searchInput .el-input__inner{
	box-sizing: content-box;
		padding-right: 15px;
		margin-right:15px;
}
.search .el-input--small{
	
	padding-right: 8px;
	/* padding-right: 13px; */
}
.search_button{
	background:url("../../assets/images/search_button.png");
	display: inline-block;
    width: 15px;
    height: 15px;
}
</style>
